"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.HiddenRows = void 0;
var _hiddenRows = require("./hiddenRows");
exports.PLUGIN_KEY = _hiddenRows.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _hiddenRows.PLUGIN_PRIORITY;
exports.HiddenRows = _hiddenRows.HiddenRows;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/hiddenRows/index.js
// module id = 1443
// module chunks = 0